<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="sign-up-container">
  <div class="container">
    <a [routerLink]="commonRoutes.prelogin.home">
      <img alt="Logo" width="180" src="/assets/img/svgs/logo-redesign.svg" class="logo max-w-100" />
    </a>
    <div class="zero-text p-huge-med mb-3">
      {{
        (showPasswordResetRequiredMessage ? 'forgot-password.set-password.reset-required.headline' : 'forgot-password.initial.headline')
          | transloco
      }}
    </div>
    <div class="mb-4">
      @if (!isPasswordForgotten()) {
        @if (showPasswordResetRequiredMessage) {
          <p [innerHTML]="'forgot-password.set-password.reset-required.hint' | transloco"></p>
        }
        {{ 'forgot-password.set-password.hint' | transloco }}
      }
      @if (isPasswordForgotten()) {
        {{ 'forgot-password.initial.hint' | transloco }}
      }
    </div>

    @if (!isPasswordForgotten()) {
      <form (ngSubmit)="onSubmit()" #pwdResetForm="ngForm" autocomplete="off">
        <web-design-system-input
          [label]="'forgot-password.initial.email.label' | transloco"
          [value]="email$ | async"
          (valueChange)="handleEmailChange($event)"
          [isValid]="email$ | async | email"
          [error]="(email$ | async | email) === false ? ('forgot-password.initial.email.error' | transloco) : undefined"
          class="d-block mb-5"
          data-zid="email"
        />
        <div class="mt-4 d-block d-md-flex justify-content-between align-items-center">
          <a class="d-block zero-text link mb-3 mb-md-0" data-zid="link-verification-state" (click)="setPasswordForgottenState()">
            {{ 'forgot-password.initial.link' | transloco }}
          </a>
          <web-design-system-button
            [isSubmit]="true"
            [fullwidth]="true"
            data-zid="submit"
            [disabled]="(isValidInitialForm$ | async) === false"
          >
            {{ 'forgot-password.initial.btn' | transloco }}
          </web-design-system-button>
        </div>
      </form>
    }
    @if (isPasswordForgotten()) {
      <form #f="ngForm" (ngSubmit)="setNewPasswordAfterForgotten()">
        <web-design-system-input
          [label]="'forgot-password.set-password.email.label' | transloco"
          [value]="email$ | async"
          (valueChange)="handleEmailChange($event)"
          [isValid]="email$ | async | email"
          class="d-block mb-4"
          data-zid="email"
        />
        <web-design-system-input
          type="password"
          [label]="'forgot-password.set-password.new-password.label' | transloco"
          [value]="password$ | async"
          (valueChange)="handlePasswordChange($event)"
          [isValid]="password$ | async | password"
          [error]="(password$ | async | password) === false ? ('forgot-password.set-password.new-password.error' | transloco) : null"
          class="d-block mb-4"
          data-zid="pass"
        />
        <web-design-system-input
          type="password"
          [label]="'forgot-password.set-password.code.label' | transloco"
          [value]="verificationCode$ | async"
          (valueChange)="handleVerificationCodeChange($event)"
          [isValid]="verificationCode$ | async | verificationCode"
          [error]="
            (verificationCode$ | async | verificationCode) === false ? ('forgot-password.set-password.code.error' | transloco) : null
          "
          class="d-block mb-5"
          data-zid="verification-code"
        />
        <div class="d-flex justify-content-between align-items-center">
          <a class="zero-text link" data-zid="link-verification-state" (click)="resetComponentState()">
            {{ 'forgot-password.set-password.link' | transloco }}
          </a>
          <web-design-system-button
            [isSubmit]="true"
            [fullwidth]="true"
            data-zid="submit"
            [disabled]="(isValidSetPasswordForm$ | async) === false"
          >
            {{ 'forgot-password.set-password.btn' | transloco }}
          </web-design-system-button>
        </div>
      </form>
    }

    <web-components-user-messages class="d-block mt-3 zero-text p-xsmall-reg" data-zid="user-message-forgot-pass" />
    @if (displayHelp) {
      <p class="zero-text p-xsmall-reg">{{ 'forgot-password.set-password.help.headline' | transloco }}</p>
      <ul class="list-square">
        @for (item of [1, 2, 3, 4, 5]; track $index) {
          <li class="zero-text p-xsmall-reg">{{ 'forgot-password.set-password.help.list.' + item | transloco }}</li>
        }
      </ul>
    }
  </div>
</div>
<onboarding-footer [hideLogout]="true" />
